export default {
  applicationID: 'UBRTTO86QQ',
  searchAPIKey: '7c6d893e57c1a54e5887018a1b0e8740',
  defaultIndex: 'knowledge_base',
}
